import type React from "react";

import { connect } from "react-redux";

import { tableActionsCreator } from "app/actions/tableActions";
import { showSuccessToast } from "app/actions/toast_actions";
import { DomainSelection } from "app/components/React/TableSelectionComponents/DomainSelection";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import type { EntityKey } from "app/common/keyword-research/serp-players/consts";
import { entities } from "app/common/keyword-research/serp-players/consts";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";
import type { RootState, ThunkDispatchCommon } from "single-spa/store/types";

const defaultEntity: EntityKey = "domain";

interface IDomainSelectionWrapperProps {
    tableSelectionKey: string;
    tableSelectionProperty: string;
    trackingOnModifyGroup?: () => void;
    initialIsVisible?: boolean;
    createGroupButtonKey?: string;
    addToGroupButtonKey?: string;
    searchListsPlaceholderKey?: string;
    targetStateForGroupVisit?: string;
    keywordGapAnalysis?: string;
    keywordGapAnalysisTargetState?: string;
    entity?: EntityKey;
}

const DomainSelectionWrapperInner = ({
    selectedRows,
    clearAllSelectedRows,
    showToast,
    initialIsVisible = true,
    createGroupButtonKey,
    addToGroupButtonKey,
    searchListsPlaceholderKey,
    targetStateForGroupVisit,
    keywordGapAnalysis,
    keywordGapAnalysisTargetState,
    entity = defaultEntity,
}: IDomainSelectionWrapperProps & {
    selectedRows: FixmeType;
    clearAllSelectedRows: () => void;
    showToast: (href: string, text: string, label: string) => void;
}) => {
    return (
        <DomainSelection
            showToast={showToast}
            clearAllSelectedRows={clearAllSelectedRows}
            selectedRows={selectedRows}
            initialIsVisible={initialIsVisible}
            createGroupButtonKey={createGroupButtonKey}
            addToGroupButtonKey={addToGroupButtonKey}
            searchListsPlaceholderKey={searchListsPlaceholderKey}
            targetStateForGroupVisit={targetStateForGroupVisit}
            keywordGapAnalysis={keywordGapAnalysis}
            keywordGapAnalysisTargetState={keywordGapAnalysisTargetState}
            entity={entities[entity]}
        />
    );
};

const mapStateToProps = (state: RootState, ownProps: IDomainSelectionWrapperProps) => {
    const { tableSelectionKey } = ownProps;
    const selectedRows = getTableSelectedItems(tableSelectionKey)(state);
    return {
        selectedRows,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatchCommon, ownProps: IDomainSelectionWrapperProps) => {
    const { tableSelectionKey, tableSelectionProperty, trackingOnModifyGroup } = ownProps;

    const tableAction = tableActionsCreator(tableSelectionKey, tableSelectionProperty);
    return {
        selectRows: (rows: FixmeType) => {
            dispatch(tableAction.selectRows(rows));
            dispatch(tableAction.clearAllSelectedRows());
        },
        clearAllSelectedRows: () => {
            dispatch(tableAction.clearAllSelectedRows());
        },
        showToast: (href: string, text: string, label: string) => {
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text,
                        linkText: label,
                        href,
                        onClick: () => {
                            trackingOnModifyGroup?.();
                        },
                    }),
                ),
            );
        },
    };
};

export const DomainSelectionWrapper: React.FC<IDomainSelectionWrapperProps> = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DomainSelectionWrapperInner);
